import { fontFamilyBlackerDisplay, fontFamilyMonserrat, gecinaBlueMain, gecinaBrownMain, WHITE } from '../../../theme'
import { Box } from '@mui/material'
import liens from '../../../enum/liens'
import { filtresListeAvisResponseEnum } from '../../listeAvis/enums/listeAvisEnum'
import React from 'react'
import { DetailAvisResponseModel } from '../types/detailAvisModel'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import Button from '../../../components/button/Button'
import { buttonTypesEnum } from '../../../components/button/enums/buttonTypesEnum'
import { displaySnackbar } from '../../../components/snackBar/reducer/actions'
import { ERREUR_ID } from '../../../components/snackBar/SnackBar'
import { exportAvis } from '../api/traitementAvisAPI'
import { detailAvisResponseEnum } from '../enums/detailAvisEnum'

interface BandeauAvisTraiteeProps {
	avis: DetailAvisResponseModel | null,
	consultationTaxes: boolean
}

type AcceptingProps = BandeauAvisTraiteeProps

const BandeauAvisTraitee: React.FC<AcceptingProps>  = (
	{
		avis,
		consultationTaxes
	}
) => {
	const navigate = useNavigate()
	const dispatch = useDispatch()

	const telechargerExport = () => {
		const reference = avis![filtresListeAvisResponseEnum.reference] ?? ''
		exportAvis(avis![detailAvisResponseEnum.id])
			.then((fichier) => {
				const url = URL.createObjectURL(fichier)
				const a = document.createElement('a')
				a.href = url
				a.download = `export_avis_${reference.replace(/[ /\\]/g, '_')}.xlsx`
				a.click()
				URL.revokeObjectURL(url)
			})
			.catch(() => dispatch(displaySnackbar(
				{
					id: ERREUR_ID,
					message: 'L\'export de l\'avis a échoué',
					open: true,
					hideIcon: false
				})
			))
	}

	return <Box sx={{ background: gecinaBlueMain, minHeight: '192px', paddingX: '172px' }}>
		<Box onClick={() => navigate(consultationTaxes ? liens.taxes : liens.avis, { state: { rafraichir: true } })}
		     sx={{
			     width: 'fit-content',
			     fontFamily: fontFamilyMonserrat,
			     fontSize: 16,
			     color: gecinaBrownMain,
			     display: 'flex',
			     flexDirection: 'row',
			     paddingTop: '21px',
			     '&:hover': { cursor: 'pointer' }
		     }}
		>
			<img src="/img/back_arrow.png" height={20} alt="Retour" />
			<Box sx={{ marginLeft: '10px' }}>Retour à la liste</Box>
		</Box>

		<Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-end' }}>
			<Box sx={{ paddingTop: '22px', fontFamily: fontFamilyBlackerDisplay, fontSize: 28, fontWeight: 900 }}>
				{avis![filtresListeAvisResponseEnum.reference]}
			</Box>
			{
				consultationTaxes &&
				<Button
					sx={{
						height: 51,
						p: 0,
						width: 195,
						fontWeight: 600,
						lineHeight: '18.29px'
					}}
					bgcolor={gecinaBrownMain}
					color={WHITE}
					border={false}
					type={buttonTypesEnum.button}
					onClick={telechargerExport}
				>
					Exporter
				</Button>
			}
		</Box>

		<Box
			sx={{
				display: 'flex',
				flexDirection: 'row',
				paddingTop: '40px',
				fontFamily: fontFamilyMonserrat
			}}
		>
			<Box>
				<Box sx={{ fontSize: 12 }}>Département</Box>
				<Box sx={{ fontWeight: 600 }}>{avis![filtresListeAvisResponseEnum.departement]}</Box>
			</Box>

			<Box sx={{ marginLeft: '180px' }}>
				<Box sx={{ fontSize: 12 }}>Commune</Box>
				<Box sx={{ fontWeight: 600 }}>{avis![filtresListeAvisResponseEnum.commune]}</Box>
			</Box>

			<Box sx={{ marginLeft: '180px' }}>
				<Box sx={{ fontSize: 12 }}>Date d'établissement</Box>
				<Box sx={{ fontWeight: 600 }}>{new Date(avis![filtresListeAvisResponseEnum.dateComptable]).toLocaleDateString()}</Box>
			</Box>

			<Box sx={{ marginLeft: '180px' }}>
				<Box sx={{ fontSize: 12 }}>Date limite de paiement</Box>
				<Box sx={{ fontWeight: 600 }}>{new Date(avis![filtresListeAvisResponseEnum.dateExigibilite]).toLocaleDateString()}</Box>
			</Box>

			<Box sx={{ marginLeft: '180px' }}>
				<Box sx={{ fontSize: 12 }}>Statut</Box>
				<Box sx={{ fontWeight: 600 }}>{avis![filtresListeAvisResponseEnum.statut]}</Box>
			</Box>
		</Box>
	</Box>
}

export default BandeauAvisTraitee